import { render, staticRenderFns } from "./UpdateIndividualTask.vue?vue&type=template&id=985c2a26&"
import script from "./UpdateIndividualTask.vue?vue&type=script&lang=js&"
export * from "./UpdateIndividualTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports